module.exports = __webpack_public_path__ + "static/media/ic_locate_stroke.1c007b5f.svg";